export const SELLER_SIGNUP_ACTION="SELLER_SIGNUP_ACTION"